<template>
    <div>
        <h1>Events</h1>
        <v-container>
            <v-flex v-for="event in this.events" :key="event.id">
                <v-card v-bind:to="{ name: 'event', params: { id: event.id} }">
                    <v-card-title>{{ event.name }}</v-card-title>
                </v-card>
            </v-flex>
        </v-container>
    </div>
</template>
<script>
    import firebase from 'firebase'
    export default {
        data() {
            return {
                events: [
                ]
            }
        },
        methods: {
        },
        mounted() {
            const self = this;
            const user = firebase.auth().currentUser
            const db = firebase.firestore()
            const userRef = db.collection("users").doc(user.uid)
            const eventRef = userRef.collection("events")
            eventRef.onSnapshot(function(querySnapshot) {
                self.events = []
                querySnapshot.forEach(function(doc) {
                    self.events.push({
                        id: doc.id,
                        name: doc.data().name,
                        updated: doc.data().updatedAt
                    })
                })
            })
        }
    }

</script>